export const TRAIN_COLORS = ["red", "orange", "yellow", "green", "blue", "purple", "black", "white"] as const;
export type TrainColor = typeof TRAIN_COLORS[number] | "locomotive";

export type TicketToRideCity = { id: string; name: string; x: number; y: number };
export type TicketToRideRoute = {
  id: string;
  from: string;
  to: string;
  length: number;
  color: Exclude<TrainColor, "locomotive"> | "gray";
  pair?: string;
};
export type DestinationTicket = { id: string; from: string; to: string; points: number };

export const TICKET_TO_RIDE_CITIES: TicketToRideCity[] = [
  { id: "vancouver", name: "Vancouver", x: 7, y: 9 }, { id: "calgary", name: "Calgary", x: 20, y: 12 },
  { id: "winnipeg", name: "Winnipeg", x: 39, y: 11 }, { id: "sault", name: "Sault Ste. Marie", x: 62, y: 18 },
  { id: "montreal", name: "Montréal", x: 80, y: 14 }, { id: "boston", name: "Boston", x: 90, y: 25 },
  { id: "seattle", name: "Seattle", x: 8, y: 21 }, { id: "helena", name: "Helena", x: 26, y: 28 },
  { id: "duluth", name: "Duluth", x: 49, y: 29 }, { id: "toronto", name: "Toronto", x: 70, y: 28 },
  { id: "new_york", name: "New York", x: 84, y: 36 }, { id: "portland", name: "Portland", x: 7, y: 33 },
  { id: "salt_lake", name: "Salt Lake City", x: 25, y: 45 }, { id: "denver", name: "Denver", x: 38, y: 46 },
  { id: "omaha", name: "Omaha", x: 51, y: 43 }, { id: "chicago", name: "Chicago", x: 61, y: 38 },
  { id: "pittsburgh", name: "Pittsburgh", x: 75, y: 41 }, { id: "washington", name: "Washington", x: 81, y: 51 },
  { id: "san_francisco", name: "San Francisco", x: 8, y: 54 }, { id: "las_vegas", name: "Las Vegas", x: 20, y: 61 },
  { id: "santa_fe", name: "Santa Fe", x: 36, y: 62 }, { id: "kansas_city", name: "Kansas City", x: 51, y: 55 },
  { id: "saint_louis", name: "Saint Louis", x: 61, y: 53 }, { id: "nashville", name: "Nashville", x: 68, y: 61 },
  { id: "raleigh", name: "Raleigh", x: 79, y: 62 }, { id: "charleston", name: "Charleston", x: 82, y: 72 },
  { id: "los_angeles", name: "Los Angeles", x: 15, y: 75 }, { id: "phoenix", name: "Phoenix", x: 27, y: 72 },
  { id: "el_paso", name: "El Paso", x: 38, y: 78 }, { id: "oklahoma_city", name: "Oklahoma City", x: 51, y: 68 },
  { id: "little_rock", name: "Little Rock", x: 61, y: 69 }, { id: "atlanta", name: "Atlanta", x: 73, y: 71 },
  { id: "new_orleans", name: "New Orleans", x: 64, y: 84 }, { id: "dallas", name: "Dallas", x: 51, y: 79 },
  { id: "houston", name: "Houston", x: 53, y: 88 }, { id: "miami", name: "Miami", x: 85, y: 91 },
];

export const TICKET_TO_RIDE_ROUTES: TicketToRideRoute[] = [
  { id: "vancouver-calgary", from: "vancouver", to: "calgary", length: 3, color: "gray" },
  { id: "vancouver-seattle-a", from: "vancouver", to: "seattle", length: 1, color: "gray", pair: "vancouver-seattle" },
  { id: "vancouver-seattle-b", from: "vancouver", to: "seattle", length: 1, color: "gray", pair: "vancouver-seattle" },
  { id: "seattle-calgary", from: "seattle", to: "calgary", length: 4, color: "gray" },
  { id: "calgary-winnipeg", from: "calgary", to: "winnipeg", length: 6, color: "white" },
  { id: "winnipeg-sault", from: "winnipeg", to: "sault", length: 6, color: "gray" },
  { id: "sault-montreal", from: "sault", to: "montreal", length: 5, color: "black" },
  { id: "montreal-boston-a", from: "montreal", to: "boston", length: 2, color: "gray", pair: "montreal-boston" },
  { id: "montreal-boston-b", from: "montreal", to: "boston", length: 2, color: "gray", pair: "montreal-boston" },
  { id: "montreal-new_york", from: "montreal", to: "new_york", length: 3, color: "blue" },
  { id: "boston-new_york-a", from: "boston", to: "new_york", length: 2, color: "yellow", pair: "boston-new_york" },
  { id: "boston-new_york-b", from: "boston", to: "new_york", length: 2, color: "red", pair: "boston-new_york" },
  { id: "seattle-portland-a", from: "seattle", to: "portland", length: 1, color: "gray", pair: "seattle-portland" },
  { id: "seattle-portland-b", from: "seattle", to: "portland", length: 1, color: "gray", pair: "seattle-portland" },
  { id: "seattle-helena", from: "seattle", to: "helena", length: 6, color: "yellow" },
  { id: "calgary-helena", from: "calgary", to: "helena", length: 4, color: "gray" },
  { id: "calgary-duluth", from: "calgary", to: "duluth", length: 6, color: "gray" },
  { id: "winnipeg-helena", from: "winnipeg", to: "helena", length: 4, color: "blue" },
  { id: "winnipeg-duluth", from: "winnipeg", to: "duluth", length: 4, color: "black" },
  { id: "sault-duluth", from: "sault", to: "duluth", length: 3, color: "gray" },
  { id: "sault-toronto", from: "sault", to: "toronto", length: 2, color: "gray" },
  { id: "montreal-toronto", from: "montreal", to: "toronto", length: 3, color: "gray" },
  { id: "toronto-pittsburgh", from: "toronto", to: "pittsburgh", length: 2, color: "gray" },
  { id: "toronto-chicago", from: "toronto", to: "chicago", length: 4, color: "white" },
  { id: "new_york-pittsburgh-a", from: "new_york", to: "pittsburgh", length: 2, color: "white", pair: "new_york-pittsburgh" },
  { id: "new_york-pittsburgh-b", from: "new_york", to: "pittsburgh", length: 2, color: "green", pair: "new_york-pittsburgh" },
  { id: "new_york-washington-a", from: "new_york", to: "washington", length: 2, color: "orange", pair: "new_york-washington" },
  { id: "new_york-washington-b", from: "new_york", to: "washington", length: 2, color: "black", pair: "new_york-washington" },
  { id: "portland-san_francisco-a", from: "portland", to: "san_francisco", length: 5, color: "green", pair: "portland-san_francisco" },
  { id: "portland-san_francisco-b", from: "portland", to: "san_francisco", length: 5, color: "purple", pair: "portland-san_francisco" },
  { id: "portland-salt_lake", from: "portland", to: "salt_lake", length: 6, color: "blue" },
  { id: "helena-salt_lake", from: "helena", to: "salt_lake", length: 3, color: "purple" },
  { id: "helena-denver", from: "helena", to: "denver", length: 4, color: "green" },
  { id: "helena-omaha", from: "helena", to: "omaha", length: 5, color: "red" },
  { id: "helena-duluth", from: "helena", to: "duluth", length: 6, color: "orange" },
  { id: "duluth-omaha-a", from: "duluth", to: "omaha", length: 2, color: "gray", pair: "duluth-omaha" },
  { id: "duluth-omaha-b", from: "duluth", to: "omaha", length: 2, color: "gray", pair: "duluth-omaha" },
  { id: "duluth-chicago", from: "duluth", to: "chicago", length: 3, color: "red" },
  { id: "chicago-pittsburgh-a", from: "chicago", to: "pittsburgh", length: 3, color: "orange", pair: "chicago-pittsburgh" },
  { id: "chicago-pittsburgh-b", from: "chicago", to: "pittsburgh", length: 3, color: "black", pair: "chicago-pittsburgh" },
  { id: "pittsburgh-washington", from: "pittsburgh", to: "washington", length: 2, color: "gray" },
  { id: "pittsburgh-raleigh", from: "pittsburgh", to: "raleigh", length: 2, color: "gray" },
  { id: "san_francisco-salt_lake-a", from: "san_francisco", to: "salt_lake", length: 5, color: "orange", pair: "san_francisco-salt_lake" },
  { id: "san_francisco-salt_lake-b", from: "san_francisco", to: "salt_lake", length: 5, color: "white", pair: "san_francisco-salt_lake" },
  { id: "san_francisco-los_angeles-a", from: "san_francisco", to: "los_angeles", length: 3, color: "yellow", pair: "san_francisco-los_angeles" },
  { id: "san_francisco-los_angeles-b", from: "san_francisco", to: "los_angeles", length: 3, color: "purple", pair: "san_francisco-los_angeles" },
  { id: "salt_lake-las_vegas", from: "salt_lake", to: "las_vegas", length: 3, color: "orange" },
  { id: "salt_lake-denver-a", from: "salt_lake", to: "denver", length: 3, color: "red", pair: "salt_lake-denver" },
  { id: "salt_lake-denver-b", from: "salt_lake", to: "denver", length: 3, color: "yellow", pair: "salt_lake-denver" },
  { id: "denver-omaha", from: "denver", to: "omaha", length: 4, color: "purple" },
  { id: "omaha-chicago", from: "omaha", to: "chicago", length: 4, color: "blue" },
  { id: "denver-kansas_city-a", from: "denver", to: "kansas_city", length: 4, color: "black", pair: "denver-kansas_city" },
  { id: "denver-kansas_city-b", from: "denver", to: "kansas_city", length: 4, color: "orange", pair: "denver-kansas_city" },
  { id: "omaha-kansas_city-a", from: "omaha", to: "kansas_city", length: 1, color: "gray", pair: "omaha-kansas_city" },
  { id: "omaha-kansas_city-b", from: "omaha", to: "kansas_city", length: 1, color: "gray", pair: "omaha-kansas_city" },
  { id: "chicago-saint_louis-a", from: "chicago", to: "saint_louis", length: 2, color: "green", pair: "chicago-saint_louis" },
  { id: "chicago-saint_louis-b", from: "chicago", to: "saint_louis", length: 2, color: "white", pair: "chicago-saint_louis" },
  { id: "pittsburgh-saint_louis", from: "pittsburgh", to: "saint_louis", length: 5, color: "green" },
  { id: "pittsburgh-nashville", from: "pittsburgh", to: "nashville", length: 4, color: "yellow" },
  { id: "washington-raleigh-a", from: "washington", to: "raleigh", length: 2, color: "gray", pair: "washington-raleigh" },
  { id: "washington-raleigh-b", from: "washington", to: "raleigh", length: 2, color: "gray", pair: "washington-raleigh" },
  { id: "los_angeles-las_vegas", from: "los_angeles", to: "las_vegas", length: 2, color: "gray" },
  { id: "los_angeles-phoenix", from: "los_angeles", to: "phoenix", length: 3, color: "gray" },
  { id: "los_angeles-el_paso", from: "los_angeles", to: "el_paso", length: 6, color: "black" },
  { id: "phoenix-santa_fe", from: "phoenix", to: "santa_fe", length: 3, color: "gray" },
  { id: "phoenix-el_paso", from: "phoenix", to: "el_paso", length: 3, color: "gray" },
  { id: "santa_fe-denver", from: "santa_fe", to: "denver", length: 2, color: "gray" },
  { id: "santa_fe-oklahoma_city", from: "santa_fe", to: "oklahoma_city", length: 3, color: "blue" },
  { id: "santa_fe-el_paso", from: "santa_fe", to: "el_paso", length: 2, color: "gray" },
  { id: "kansas_city-oklahoma_city-a", from: "kansas_city", to: "oklahoma_city", length: 2, color: "gray", pair: "kansas_city-oklahoma_city" },
  { id: "kansas_city-oklahoma_city-b", from: "kansas_city", to: "oklahoma_city", length: 2, color: "gray", pair: "kansas_city-oklahoma_city" },
  { id: "kansas_city-saint_louis-a", from: "kansas_city", to: "saint_louis", length: 2, color: "blue", pair: "kansas_city-saint_louis" },
  { id: "kansas_city-saint_louis-b", from: "kansas_city", to: "saint_louis", length: 2, color: "purple", pair: "kansas_city-saint_louis" },
  { id: "saint_louis-nashville", from: "saint_louis", to: "nashville", length: 2, color: "gray" },
  { id: "saint_louis-little_rock", from: "saint_louis", to: "little_rock", length: 2, color: "gray" },
  { id: "nashville-raleigh", from: "nashville", to: "raleigh", length: 3, color: "black" },
  { id: "nashville-atlanta", from: "nashville", to: "atlanta", length: 1, color: "gray" },
  { id: "raleigh-charleston", from: "raleigh", to: "charleston", length: 2, color: "gray" },
  { id: "raleigh-atlanta-a", from: "raleigh", to: "atlanta", length: 2, color: "gray", pair: "raleigh-atlanta" },
  { id: "raleigh-atlanta-b", from: "raleigh", to: "atlanta", length: 2, color: "gray", pair: "raleigh-atlanta" },
  { id: "el_paso-oklahoma_city", from: "el_paso", to: "oklahoma_city", length: 5, color: "yellow" },
  { id: "el_paso-dallas", from: "el_paso", to: "dallas", length: 4, color: "red" },
  { id: "el_paso-houston", from: "el_paso", to: "houston", length: 6, color: "green" },
  { id: "oklahoma_city-little_rock", from: "oklahoma_city", to: "little_rock", length: 2, color: "gray" },
  { id: "oklahoma_city-dallas-a", from: "oklahoma_city", to: "dallas", length: 2, color: "gray", pair: "oklahoma_city-dallas" },
  { id: "oklahoma_city-dallas-b", from: "oklahoma_city", to: "dallas", length: 2, color: "gray", pair: "oklahoma_city-dallas" },
  { id: "little_rock-nashville", from: "little_rock", to: "nashville", length: 3, color: "white" },
  { id: "little_rock-new_orleans", from: "little_rock", to: "new_orleans", length: 3, color: "green" },
  { id: "little_rock-dallas", from: "little_rock", to: "dallas", length: 2, color: "gray" },
  { id: "atlanta-charleston", from: "atlanta", to: "charleston", length: 2, color: "gray" },
  { id: "atlanta-new_orleans-a", from: "atlanta", to: "new_orleans", length: 4, color: "yellow", pair: "atlanta-new_orleans" },
  { id: "atlanta-new_orleans-b", from: "atlanta", to: "new_orleans", length: 4, color: "orange", pair: "atlanta-new_orleans" },
  { id: "atlanta-miami", from: "atlanta", to: "miami", length: 5, color: "blue" },
  { id: "charleston-miami", from: "charleston", to: "miami", length: 4, color: "purple" },
  { id: "new_orleans-miami", from: "new_orleans", to: "miami", length: 6, color: "red" },
  { id: "dallas-houston-a", from: "dallas", to: "houston", length: 1, color: "gray", pair: "dallas-houston" },
  { id: "dallas-houston-b", from: "dallas", to: "houston", length: 1, color: "gray", pair: "dallas-houston" },
  { id: "houston-new_orleans", from: "houston", to: "new_orleans", length: 2, color: "gray" },
];

export const DESTINATION_TICKETS: DestinationTicket[] = [
  ["los_angeles", "new_york", 21], ["duluth", "houston", 8], ["sault", "nashville", 8],
  ["new_york", "atlanta", 6], ["portland", "nashville", 17], ["vancouver", "montreal", 20],
  ["duluth", "el_paso", 10], ["toronto", "miami", 10], ["portland", "phoenix", 11],
  ["dallas", "new_york", 11], ["calgary", "salt_lake", 7], ["calgary", "phoenix", 13],
  ["los_angeles", "miami", 20], ["winnipeg", "little_rock", 11], ["san_francisco", "atlanta", 17],
  ["kansas_city", "houston", 5], ["los_angeles", "chicago", 16], ["denver", "pittsburgh", 11],
  ["chicago", "santa_fe", 9], ["vancouver", "santa_fe", 13], ["boston", "miami", 12],
  ["seattle", "new_york", 22], ["helena", "los_angeles", 8], ["montreal", "new_orleans", 13],
  ["sault", "oklahoma_city", 9], ["seattle", "los_angeles", 9], ["denver", "el_paso", 4],
  ["winnipeg", "houston", 12], ["montreal", "atlanta", 9], ["chicago", "new_orleans", 7],
].map(([from, to, points]) => ({ id: `${from}-${to}`, from: String(from), to: String(to), points: Number(points) }));

export type TicketToRidePlayerState = {
  hand: TrainColor[];
  tickets: DestinationTicket[];
  pendingTickets: DestinationTicket[];
  pendingMinimum: number;
  claimedRouteIds: string[];
  trains: number;
  routeScore: number;
  ticketScore: number;
  longestRoute: number;
  unusedDepots: number;
};

export type TicketToRideState = {
  europa1912Enabled: boolean;
  playerOrder: string[];
  players: Record<string, TicketToRidePlayerState>;
  deck: TrainColor[];
  discard: TrainColor[];
  faceUp: TrainColor[];
  ticketDeck: DestinationTicket[];
  ticketDiscard: DestinationTicket[];
  claimedRoutes: Record<string, string>;
  warehouses: Record<string, TrainColor[]>;
  depots: Record<string, string>;
  currentPlayerIndex: number;
  turnStage: "setup_tickets" | "setup_depots" | "choose_action" | "draw_second" | "choose_tickets" | "finished";
  setupPlayerIndex: number;
  finalTurnsRemaining: number | null;
  finalRoundTriggeredBy: string | null;
  winnerIds: string[];
  longestRoutePlayerIds: string[];
  depotBonusPlayerIds: string[];
  lastAction: string;
  turnNumber: number;
};

export type TicketToRideAction =
  | { type: "choose_tickets"; ticketIds: unknown }
  | { type: "place_depots"; cityIds: unknown }
  | { type: "draw_train"; source: unknown; faceUpIndex?: unknown; warehousePlayerId?: unknown }
  | { type: "draw_tickets" }
  | { type: "claim_route"; routeId: unknown; paymentColor: unknown; collectDepotCityIds?: unknown };

const ROUTE_SCORE: Record<number, number> = { 1: 1, 2: 2, 3: 4, 4: 7, 5: 10, 6: 15 };

function shuffle<T>(values: T[], random = Math.random) {
  const result = [...values];
  for (let index = result.length - 1; index > 0; index -= 1) {
    const swap = Math.floor(random() * (index + 1));
    [result[index], result[swap]] = [result[swap], result[index]];
  }
  return result;
}

function createTrainDeck(random = Math.random) {
  return shuffle<TrainColor>([...TRAIN_COLORS.flatMap((color) => Array<TrainColor>(12).fill(color)), ...Array<TrainColor>(14).fill("locomotive")], random);
}

export function createInitialTicketToRideState(): TicketToRideState {
  return {
    europa1912Enabled: false,
    playerOrder: [], players: {}, deck: [], discard: [], faceUp: [], ticketDeck: [], ticketDiscard: [],
    warehouses: {}, depots: {},
    claimedRoutes: {}, currentPlayerIndex: 0, turnStage: "setup_tickets", setupPlayerIndex: 0,
    finalTurnsRemaining: null, finalRoundTriggeredBy: null, winnerIds: [], longestRoutePlayerIds: [], depotBonusPlayerIds: [],
    lastAction: "", turnNumber: 0,
  };
}

export function setTicketToRideEuropa1912(state: TicketToRideState, enabled: unknown) {
  if (typeof enabled !== "boolean" || state.playerOrder.length > 0) return false;
  state.europa1912Enabled = enabled;
  return true;
}

function refillDeck(state: TicketToRideState, random = Math.random) {
  if (state.deck.length || !state.discard.length) return;
  state.deck = shuffle(state.discard, random);
  state.discard = [];
}

function drawDeckCard(state: TicketToRideState, random = Math.random) {
  refillDeck(state, random);
  return state.deck.pop() || null;
}

function refillDeckFromWarehouses(state: TicketToRideState, random = Math.random) {
  refillDeck(state, random);
  if (state.deck.length || !state.europa1912Enabled) return;
  if (!state.playerOrder.some((id) => (state.players[id]?.unusedDepots ?? 5) === 0)) return;
  const stored = state.playerOrder.flatMap((id) => state.warehouses[id] || []);
  if (!stored.length) return;
  state.playerOrder.forEach((id) => { state.warehouses[id] = []; });
  state.deck = shuffle(stored, random);
}

function drawWarehouseCard(state: TicketToRideState, random = Math.random) {
  refillDeckFromWarehouses(state, random);
  return state.deck.pop() || null;
}

function refillFaceUp(state: TicketToRideState, random = Math.random) {
  while (state.faceUp.length < 5) {
    const card = drawDeckCard(state, random);
    if (!card) break;
    state.faceUp.push(card);
  }
  let resets = 0;
  while (state.faceUp.length === 5 && state.faceUp.filter((card) => card === "locomotive").length >= 3) {
    const supply = [...state.deck, ...state.discard, ...state.faceUp];
    // Near the end of a game there may be fewer than three regular cards left
    // anywhere in the supply, making a legal five-card market impossible.
    if (supply.filter((card) => card !== "locomotive").length < 3) break;

    // A well-behaved random source reaches a legal market quickly. The bounded
    // fallback also guarantees termination for deterministic/adversarial RNGs.
    if (resets >= 20) {
      const remaining = [...supply];
      const regulars: TrainColor[] = [];
      for (let index = remaining.length - 1; index >= 0 && regulars.length < 3; index -= 1) {
        if (remaining[index] !== "locomotive") regulars.push(...remaining.splice(index, 1));
      }
      const shuffledRemaining = shuffle(remaining, random);
      state.faceUp = [...regulars, ...shuffledRemaining.splice(-2)];
      state.deck = shuffledRemaining;
      state.discard = [];
      break;
    }

    state.discard.push(...state.faceUp);
    state.faceUp = [];
    while (state.faceUp.length < 5) {
      const card = drawDeckCard(state, random);
      if (!card) break;
      state.faceUp.push(card);
    }
    resets += 1;
  }
}

function drawTickets(state: TicketToRideState, count: number) {
  // Older persisted games used ticketDiscard for returned tickets. Restore
  // those cards to the bottom before drawing so they follow the table rule.
  if (state.ticketDiscard.length) {
    state.ticketDeck.unshift(...state.ticketDiscard);
    state.ticketDiscard = [];
  }
  const drawn: DestinationTicket[] = [];
  while (drawn.length < count && state.ticketDeck.length) drawn.push(state.ticketDeck.pop()!);
  return drawn;
}

function canDrawAnotherTrainCard(state: TicketToRideState) {
  const recyclableWarehouses = state.europa1912Enabled
    && state.playerOrder.some((id) => state.players[id].unusedDepots === 0)
    ? state.playerOrder.reduce((count, id) => count + (state.warehouses[id]?.length || 0), 0)
    : 0;
  return state.deck.length + state.discard.length + recyclableWarehouses > 0 || state.faceUp.some((card) => card !== "locomotive");
}

export function startTicketToRide(state: TicketToRideState, playerIds: string[], random = Math.random) {
  if (playerIds.length < 2 || playerIds.length > 5 || new Set(playerIds).size !== playerIds.length) return false;
  const europa1912Enabled = state.europa1912Enabled === true;
  const next = createInitialTicketToRideState();
  next.europa1912Enabled = europa1912Enabled;
  next.playerOrder = [...playerIds];
  next.deck = createTrainDeck(random);
  next.ticketDeck = shuffle(DESTINATION_TICKETS, random);
  for (const playerId of playerIds) {
    const hand = Array.from({ length: 4 }, () => next.deck.pop()!).filter(Boolean);
    next.players[playerId] = {
      hand, tickets: [], pendingTickets: drawTickets(next, 3), pendingMinimum: 2,
      claimedRouteIds: [], trains: 45, routeScore: 0, ticketScore: 0, longestRoute: 0,
      unusedDepots: europa1912Enabled ? 5 : 0,
    };
    if (europa1912Enabled) next.warehouses[playerId] = [];
  }
  refillFaceUp(next, random);
  next.lastAction = "Choose at least two starting destination tickets.";
  Object.assign(state, next);
  return true;
}

export function currentTicketToRidePlayerId(state: TicketToRideState) {
  return state.playerOrder[state.currentPlayerIndex] || null;
}

export function routeIsAvailable(state: TicketToRideState, route: TicketToRideRoute, playerId: string) {
  if (state.claimedRoutes[route.id]) return false;
  if (route.pair) {
    const parallel = TICKET_TO_RIDE_ROUTES.filter((candidate) => candidate.pair === route.pair);
    if (parallel.some((candidate) => state.claimedRoutes[candidate.id] === playerId)) return false;
    if (state.playerOrder.length <= 3 && parallel.some((candidate) => state.claimedRoutes[candidate.id])) return false;
  }
  return true;
}

export function canPayForRoute(player: TicketToRidePlayerState, route: TicketToRideRoute, color: unknown) {
  if (!TRAIN_COLORS.includes(color as Exclude<TrainColor, "locomotive">)) return false;
  const paymentColor = color as Exclude<TrainColor, "locomotive">;
  if (route.color !== "gray" && route.color !== paymentColor) return false;
  return player.hand.filter((card) => card === paymentColor || card === "locomotive").length >= route.length;
}

function spendCards(player: TicketToRidePlayerState, route: TicketToRideRoute, paymentColor: Exclude<TrainColor, "locomotive">) {
  const colored = Math.min(route.length, player.hand.filter((card) => card === paymentColor).length);
  let colorRemaining = colored;
  let locomotivesRemaining = route.length - colored;
  const spent: TrainColor[] = [];
  player.hand = player.hand.filter((card) => {
    if (card === paymentColor && colorRemaining > 0) { colorRemaining -= 1; spent.push(card); return false; }
    if (card === "locomotive" && locomotivesRemaining > 0) { locomotivesRemaining -= 1; spent.push(card); return false; }
    return true;
  });
  return spent;
}

function endTurn(state: TicketToRideState) {
  const endingPlayerId = currentTicketToRidePlayerId(state)!;
  if (state.finalTurnsRemaining !== null) {
    state.finalTurnsRemaining -= 1;
    if (state.finalTurnsRemaining <= 0) return finishTicketToRide(state);
  } else if (state.players[endingPlayerId].trains <= 2) {
    state.finalRoundTriggeredBy = endingPlayerId;
    state.finalTurnsRemaining = state.playerOrder.length;
  }
  state.currentPlayerIndex = (state.currentPlayerIndex + 1) % state.playerOrder.length;
  state.turnNumber += 1;
  state.turnStage = "choose_action";
  return true;
}

function ticketConnected(state: TicketToRideState, playerId: string, ticket: DestinationTicket) {
  const adjacency = new Map<string, string[]>();
  for (const routeId of state.players[playerId].claimedRouteIds) {
    const route = TICKET_TO_RIDE_ROUTES.find((candidate) => candidate.id === routeId);
    if (!route) continue;
    adjacency.set(route.from, [...(adjacency.get(route.from) || []), route.to]);
    adjacency.set(route.to, [...(adjacency.get(route.to) || []), route.from]);
  }
  const seen = new Set([ticket.from]);
  const queue = [ticket.from];
  while (queue.length) {
    const city = queue.shift()!;
    if (city === ticket.to) return true;
    for (const next of adjacency.get(city) || []) if (!seen.has(next)) { seen.add(next); queue.push(next); }
  }
  return false;
}

export function longestContinuousRoute(state: TicketToRideState, playerId: string) {
  const routes = state.players[playerId]?.claimedRouteIds.map((id) => TICKET_TO_RIDE_ROUTES.find((route) => route.id === id)).filter((route): route is TicketToRideRoute => Boolean(route)) || [];
  const byCity = new Map<string, TicketToRideRoute[]>();
  for (const route of routes) {
    byCity.set(route.from, [...(byCity.get(route.from) || []), route]);
    byCity.set(route.to, [...(byCity.get(route.to) || []), route]);
  }
  const walk = (city: string, used: Set<string>): number => {
    let best = 0;
    for (const route of byCity.get(city) || []) {
      if (used.has(route.id)) continue;
      used.add(route.id);
      const next = route.from === city ? route.to : route.from;
      best = Math.max(best, route.length + walk(next, used));
      used.delete(route.id);
    }
    return best;
  };
  return Math.max(0, ...[...byCity.keys()].map((city) => walk(city, new Set())));
}

export function finishTicketToRide(state: TicketToRideState) {
  state.turnStage = "finished";
  for (const playerId of state.playerOrder) {
    const player = state.players[playerId];
    player.ticketScore = player.tickets.reduce((score, ticket) => score + (ticketConnected(state, playerId, ticket) ? ticket.points : -ticket.points), 0);
    player.longestRoute = longestContinuousRoute(state, playerId);
  }
  const longest = Math.max(...state.playerOrder.map((id) => state.players[id].longestRoute));
  state.longestRoutePlayerIds = longest > 0 ? state.playerOrder.filter((id) => state.players[id].longestRoute === longest) : [];
  if (state.europa1912Enabled) {
    const mostUnusedDepots = Math.max(...state.playerOrder.map((id) => state.players[id].unusedDepots));
    state.depotBonusPlayerIds = state.playerOrder.filter((id) => state.players[id].unusedDepots === mostUnusedDepots);
  } else state.depotBonusPlayerIds = [];
  const totals = Object.fromEntries(state.playerOrder.map((id) => [id, state.players[id].routeScore + state.players[id].ticketScore + (state.longestRoutePlayerIds.includes(id) ? 10 : 0) + (state.depotBonusPlayerIds.includes(id) ? 10 : 0)]));
  const high = Math.max(...Object.values(totals));
  const tied = state.playerOrder.filter((id) => totals[id] === high);
  const mostCompleted = Math.max(...tied.map((id) => state.players[id].tickets.filter((ticket) => ticketConnected(state, id, ticket)).length));
  const ticketLeaders = tied.filter((id) => state.players[id].tickets.filter((ticket) => ticketConnected(state, id, ticket)).length === mostCompleted);
  const pathBonusLeaders = ticketLeaders.filter((id) => state.longestRoutePlayerIds.includes(id));
  state.winnerIds = pathBonusLeaders.length ? pathBonusLeaders : ticketLeaders;
  state.lastAction = "Final routes and destination tickets have been scored.";
  return true;
}

export function ticketToRideScore(state: TicketToRideState, playerId: string) {
  const player = state.players[playerId];
  return player ? player.routeScore + (state.turnStage === "finished" ? player.ticketScore + (state.longestRoutePlayerIds.includes(playerId) ? 10 : 0) + ((state.depotBonusPlayerIds || []).includes(playerId) ? 10 : 0) : 0) : 0;
}

export function applyTicketToRideAction(state: TicketToRideState, playerId: string, action: TicketToRideAction, random = Math.random) {
  if (state.turnStage === "finished" || currentTicketToRidePlayerId(state) !== playerId) return false;
  const player = state.players[playerId];
  if (!player) return false;
  if (action.type === "choose_tickets") {
    if (!['setup_tickets', 'choose_tickets'].includes(state.turnStage) || !Array.isArray(action.ticketIds)) return false;
    const ids = [...new Set(action.ticketIds.filter((id): id is string => typeof id === "string"))];
    if (ids.length < player.pendingMinimum || ids.some((id) => !player.pendingTickets.some((ticket) => ticket.id === id))) return false;
    const kept = player.pendingTickets.filter((ticket) => ids.includes(ticket.id));
    const returned = player.pendingTickets.filter((ticket) => !ids.includes(ticket.id));
    player.tickets.push(...kept);
    // The physical rules put declined tickets on the bottom of the draw pile.
    // This deck draws from the array end, so the beginning is the bottom.
    state.ticketDeck.unshift(...returned);
    player.pendingTickets = [];
    player.pendingMinimum = 0;
    if (state.turnStage === "setup_tickets") {
      state.setupPlayerIndex += 1;
      if (state.setupPlayerIndex < state.playerOrder.length) state.currentPlayerIndex = state.setupPlayerIndex;
      else if (state.europa1912Enabled) {
        state.setupPlayerIndex = state.playerOrder.length - 1;
        state.currentPlayerIndex = state.setupPlayerIndex;
        state.turnStage = "setup_depots";
      } else { state.currentPlayerIndex = 0; state.turnStage = "choose_action"; state.turnNumber = 1; }
      state.lastAction = `A traveler kept ${kept.length} starting tickets.`;
      return true;
    }
    state.lastAction = `A traveler kept ${kept.length} destination ticket${kept.length === 1 ? "" : "s"}.`;
    return endTurn(state);
  }
  if (action.type === "place_depots") {
    if (!state.europa1912Enabled || !Array.isArray(action.cityIds) || !["setup_depots", "choose_action", "draw_second", "choose_tickets"].includes(state.turnStage)) return false;
    const cityIds = [...new Set(action.cityIds.filter((id): id is string => typeof id === "string"))];
    const requiredCount = state.turnStage === "setup_depots" ? 1 : cityIds.length;
    if (!cityIds.length || cityIds.length !== requiredCount || cityIds.length > player.unusedDepots) return false;
    if (cityIds.some((id) => !TICKET_TO_RIDE_CITIES.some((city) => city.id === id) || state.depots[id])) return false;
    for (const cityId of cityIds) state.depots[cityId] = playerId;
    player.unusedDepots -= cityIds.length;
    state.lastAction = `A traveler placed ${cityIds.length} depot${cityIds.length === 1 ? "" : "s"}.`;
    if (state.turnStage === "setup_depots") {
      state.setupPlayerIndex -= 1;
      if (state.setupPlayerIndex >= 0) state.currentPlayerIndex = state.setupPlayerIndex;
      else { state.currentPlayerIndex = 0; state.turnStage = "choose_action"; state.turnNumber = 1; }
    }
    return true;
  }
  if (state.turnStage === "setup_tickets" || state.turnStage === "setup_depots" || state.turnStage === "choose_tickets") return false;
  if (action.type === "draw_train") {
    if (!['choose_action', 'draw_second'].includes(state.turnStage) || (action.source !== "deck" && action.source !== "face_up")) return false;
    if (action.source === "face_up" && (typeof action.faceUpIndex !== "number" || !Number.isInteger(action.faceUpIndex) || action.faceUpIndex < 0 || action.faceUpIndex >= state.faceUp.length || (state.turnStage === "draw_second" && state.faceUp[action.faceUpIndex] === "locomotive"))) return false;
    if (state.europa1912Enabled && state.turnStage === "choose_action") {
      if (typeof action.warehousePlayerId !== "string" || !state.playerOrder.includes(action.warehousePlayerId)) return false;
      const recyclable = !state.deck.length && !state.discard.length && state.playerOrder.some((id) => state.players[id].unusedDepots === 0)
        ? state.playerOrder.reduce((count, id) => count + (state.warehouses[id]?.length || 0), 0)
        : 0;
      const available = state.deck.length + state.discard.length + recyclable;
      if (available < (action.source === "deck" ? 2 : 1)) return false;
    }
    let card: TrainColor | null = null;
    if (state.europa1912Enabled && state.turnStage === "choose_action") {
      const warehouseCard = drawWarehouseCard(state, random);
      if (!warehouseCard) return false;
      (state.warehouses[action.warehousePlayerId as string] ||= []).push(warehouseCard);
    }
    if (action.source === "face_up") {
      const index = action.faceUpIndex as number;
      card = state.faceUp.splice(index, 1)[0];
      refillFaceUp(state, random);
    } else card = drawDeckCard(state, random);
    if (!card) return false;
    player.hand.push(card);
    state.lastAction = "A traveler drew a train card.";
    if (state.turnStage === "choose_action" && !(action.source === "face_up" && card === "locomotive")) {
      if (!canDrawAnotherTrainCard(state)) return endTurn(state);
      state.turnStage = "draw_second";
      return true;
    }
    return endTurn(state);
  }
  if (action.type === "draw_tickets") {
    if (state.turnStage !== "choose_action") return false;
    const pending = drawTickets(state, 3);
    if (!pending.length) return false;
    player.pendingTickets = pending;
    player.pendingMinimum = 1;
    state.turnStage = "choose_tickets";
    state.lastAction = "A traveler drew destination tickets.";
    return true;
  }
  if (action.type === "claim_route") {
    if (state.turnStage !== "choose_action" || typeof action.routeId !== "string") return false;
    const route = TICKET_TO_RIDE_ROUTES.find((candidate) => candidate.id === action.routeId);
    if (!route || player.trains < route.length || !routeIsAvailable(state, route, playerId) || !canPayForRoute(player, route, action.paymentColor)) return false;
    const collectDepotCityIds = action.collectDepotCityIds === undefined ? [] : Array.isArray(action.collectDepotCityIds)
      ? [...new Set(action.collectDepotCityIds.filter((id): id is string => typeof id === "string"))]
      : null;
    if (!collectDepotCityIds || collectDepotCityIds.length > player.unusedDepots || collectDepotCityIds.some((id) => ![route.from, route.to].includes(id) || !state.depots[id]) || new Set(collectDepotCityIds.map((id) => state.depots[id])).size !== collectDepotCityIds.length) return false;
    const paymentColor = action.paymentColor as Exclude<TrainColor, "locomotive">;
    state.discard.push(...spendCards(player, route, paymentColor));
    player.trains -= route.length;
    player.routeScore += ROUTE_SCORE[route.length] || 0;
    player.claimedRouteIds.push(route.id);
    state.claimedRoutes[route.id] = playerId;
    for (const cityId of collectDepotCityIds) {
      const warehouseOwnerId = state.depots[cityId];
      player.hand.push(...(state.warehouses[warehouseOwnerId] || []));
      state.warehouses[warehouseOwnerId] = [];
      player.unusedDepots -= 1;
    }
    const fromName = TICKET_TO_RIDE_CITIES.find((city) => city.id === route.from)?.name || route.from;
    const toName = TICKET_TO_RIDE_CITIES.find((city) => city.id === route.to)?.name || route.to;
    state.lastAction = `A route was claimed from ${fromName} to ${toName}.`;
    return endTurn(state);
  }
  return false;
}

export function ticketToRidePublicView(state: TicketToRideState, viewerId?: string) {
  const viewer = viewerId ? state.players[viewerId] : undefined;
  const recyclableWarehouseCards = state.europa1912Enabled && state.playerOrder.some((id) => state.players[id].unusedDepots === 0)
    ? state.playerOrder.reduce((count, id) => count + (state.warehouses[id]?.length || 0), 0)
    : 0;
  return {
    europa1912Enabled: state.europa1912Enabled === true,
    cities: TICKET_TO_RIDE_CITIES.map((city) => ({ ...city })),
    routes: TICKET_TO_RIDE_ROUTES.map((route) => ({ ...route })),
    playerOrder: [...state.playerOrder],
    currentPlayerId: currentTicketToRidePlayerId(state),
    turnStage: state.turnStage,
    turnNumber: state.turnNumber,
    faceUp: [...state.faceUp],
    deckCount: state.deck.length + state.discard.length + recyclableWarehouseCards,
    ticketDeckCount: state.ticketDeck.length + state.ticketDiscard.length,
    claimedRoutes: { ...state.claimedRoutes },
    depots: { ...(state.depots || {}) },
    warehouseCounts: Object.fromEntries(state.playerOrder.map((id) => [id, state.warehouses?.[id]?.length || 0])),
    finalTurnsRemaining: state.finalTurnsRemaining,
    finalRoundTriggeredBy: state.finalRoundTriggeredBy,
    winnerIds: [...state.winnerIds],
    longestRoutePlayerIds: [...state.longestRoutePlayerIds],
    depotBonusPlayerIds: [...(state.depotBonusPlayerIds || [])],
    lastAction: state.lastAction,
    players: Object.fromEntries(state.playerOrder.map((id) => [id, {
      trains: state.players[id].trains,
      cardCount: state.players[id].hand.length,
      ticketCount: state.players[id].tickets.length,
      routeScore: state.players[id].routeScore,
      ticketScore: state.turnStage === "finished" ? state.players[id].ticketScore : null,
      longestRoute: state.turnStage === "finished" ? state.players[id].longestRoute : null,
      claimedRouteIds: [...state.players[id].claimedRouteIds],
      unusedDepots: state.players[id].unusedDepots || 0,
      totalScore: ticketToRideScore(state, id),
    }])),
    hand: viewer ? [...viewer.hand] : [],
    tickets: viewer?.tickets.map((ticket) => ({ ...ticket, completed: ticketConnected(state, viewerId!, ticket) })) || [],
    pendingTickets: viewer?.pendingTickets.map((ticket) => ({ ...ticket })) || [],
    pendingMinimum: viewer?.pendingMinimum || 0,
    canAct: Boolean(viewerId && viewerId === currentTicketToRidePlayerId(state) && state.turnStage !== "finished"),
  };
}
